// Large casts (ADR-0178): up to 30 scripted characters are built automatically (MAX_SCRIPTED_CHARACTERS in
// supabase/functions/_shared/orderPreflight.ts); 31 to 50 are accepted in the normal flow and hand-built in 1 to 2 business days.
// Keep AUTOMATED_CAST_LIMIT equal to MAX_SCRIPTED_CHARACTERS.
export const AUTOMATED_CAST_LIMIT = 30;
export const MAX_CAST = 50;

export const isLargeCast = (playerCount: number | null | undefined): boolean =>
  typeof playerCount === 'number' && playerCount > AUTOMATED_CAST_LIMIT;
